<template>
  <section class="section" style="margin-top: -40px;">
    <div class="container no-print">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            ແຈ້ງບັນຫາ ການເຮັດວຽກ ( {{ sectionname }})
          </h2>  
        </div>
      </div>
      
      <b-tabs v-model="activeTab" v-if="roleid == 32 || roleid == 33" style="margin-top: -20px;">
            <b-tab-item label="ແຈ້ງບັນຫາ">
              <b-field style="font-size: 16px; margin-bottom: 40px;" v-if="roleid == 32 || roleid == 33">
                ຟອມແຈ້ງບັນຫາ
              </b-field>
              <b-field grouped style="margin-top: -30px;" v-if="roleid == 32 || roleid == 33">    
                <b-field style="width: 300px;"> 
                  <Multiselect
                    placeholder="ເລືອກພາກສ່ວນຮັບຜິດຊອບ"  
                    v-model.trim="selectedSection"
                    label="NAME"
                    track-by="ID"
                    :options="sectionList"
                  >
                  </Multiselect>
                </b-field>
              
                
                <b-field style="width: 500px;"> 
                  <b-input 
                  maxlength="500"
                  v-model.trim="selectedRemark"
                  type="textarea"
                  placeholder="ລາຍລະອຽດ"
                ></b-input>
                
                </b-field>
                <b-field>
                  <b-button style="margin-top: 0px;"
                    class="btn-group-margin"
                    type="is-primary"
                    @click="saveIssue"
                    >ບັນທຶກ
                  </b-button>
                
                </b-field>
              </b-field>
              <b-field style="margin-top: 10px;"> 
                ລາຍການ ແຈ້ງບັນຫາ
              </b-field>
              <table class="table is-fullwidth is-narrow is-small">
                <thead>
                  <tr>
                  
                    <th class="has-text-centered " width="5%">
                      #
                    </th>
                    <th class="has-text-left " width="10%">
                      ວັນທີ
                    </th>
                    <th class="has-text-left " width="15%">
                      ພາກສ່ວນຮັບຜິດຊອບ
                    </th>
                    <th class="has-text-left " width="50%">
                      ເນື້ອໃນ
                    </th>
                    <th class="has-text-centered " width="15%">
                      ລາຍລະອຽດ
                    </th>
                  
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in ownIssueHistory"
                    :key="data.ID"
                  >
                    <td class="has-text-centered">
                      {{ index +1  }}
                      
                    </td>
                    <td class="has-text-centered">
                      {{ data.TXDATE }}
                    </td>
                    <td class="has-text-left">
                      {{ data.SECTIONNAME }}
                    </td>
                    <td class="has-text-left">
                      {{ data.TITLE }}
                    </td>
                    
                    <td class="has-text-centered">
                      <b-button style="margin-top: 0px;"
                        class="btn-group-margin"
                        type="is-primary"
                        @click="getStatementHitstory(data.USERNAME, data.NAME)"
                        >ລາຍລະອຽດ
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>

            </b-tab-item>
            <b-tab-item label="ບັນຫາຈາກພາກສ່ວນອື່ນ">             
              <b-field style="margin-top: 10px;">
                ລາຍການບັນຫາ
              </b-field>
              <table class="table is-fullwidth is-narrow is-small">
                <thead>
                  <tr>
                  
                    <th class="has-text-centered " width="5%">
                      #
                    </th>
                    <th class="has-text-left " width="10%">
                      ວັນທີ
                    </th>
                    <th class="has-text-left " width="15%">
                      ພາກສ່ວນຮັບຜິດຊອບ
                    </th>
                    <th class="has-text-left " width="50%">
                      ເນື້ອໃນ
                    </th>
                    <th class="has-text-centered " width="15%">
                      ລາຍລະອຽດ
                    </th>
                  
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in otherIssueHistory"
                    :key="data.ID"
                  >
                    <td class="has-text-centered">
                      {{ index +1  }}
                      
                    </td>
                    <td class="has-text-centered">
                      {{ data.TXDATE }}
                    </td>
                    <td class="has-text-left">
                      {{ data.SECTIONNAME }}
                    </td>
                    <td class="has-text-left">
                      {{ data.TITLE }}
                    </td>
                    
                    <td class="has-text-centered">
                      <b-button style="margin-top: 0px;"
                        class="btn-group-margin"
                        type="is-primary"
                        @click="getStatementHitstory(data.USERNAME, data.NAME)"
                        >ລາຍລະອຽດ
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>

            </b-tab-item>
          </b-tabs>
         
   </div>
  
    
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  components: {Multiselect },
  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      activeTab: 0,
      photopath:
        process.env.NODE_ENV === "production"
          ? "http//139.180.144.152/managerv2/api/uploads/"
          // : "http://localhost/agrilao-manager/api/uploads/",
          : "https://agrilao.com/manager-main/api/uploads/",

      sectionList: [],
      selectedSection: [],
      selectedAmount: 0,
      topupHistory: [],
      selectedOwnerName: null,
      selectedStatementTXDATE: null,
      statementDetail: [],
      selectedRemark: null,

      ownIssueHistory: [],
      otherIssueHistory: [],
      sectionname: null,

    };
  },
  methods: {
  //   getStatementDetail(ID, TXDATE){
  //     this.selectedStatementTXDATE = TXDATE;
  //     this.activeTab = 2;
  //     RestAPI.getStatementDetail(ID)
  //       .then((res) => {
  //         this.statementDetail = res.data;
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
  //       });
  //   },
    getIssueHistory() {
      RestAPI.getIssueHistory(this.username)
        .then((res) => {
          this.ownIssueHistory = res.data.ownpost;
          this.otherIssueHistory = res.data.otherpost;
          this.sectionname = res.data.section.NAME;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    // getStatementHitstory (owner, ownername) {
    //   RestAPI.getStatementHitstory(owner)
    //     .then((res) => {
    //       this.selectedOwnerName = ownername;
    //       this.activeTab = 1;
    //       this.topupHistory = res.data;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
    //     });
    // },
    saveIssue(){ 

      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#FF3860",
        cancelButtonColor: "#F7C325", 
        reverseButtons: true
      }).then((result) => {
        if (result.value) {   
          var params = {
            sectionid: this.selectedSection.ID,
            remark: this.selectedRemark,
            username: this.username,
          };
          // console.log("params: " +JSON.stringify(params))
          RestAPI.saveIssue(params)
              .then(() => {
              this.selectedRemark = [];

              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
        }
      });

    },
  
    getSectionList() {
      RestAPI.getSectionList()
        .then((res) => {
          this.sectionList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    
    getImgUrl(photoname) {
      var photopreview = photoname
        ? this.photopath + photoname
        : this.photopath + "unknown.png";
      return photopreview;
    },

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
    year(date) {
      return new moment(date).format("YYYY");
    },

    
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.getSectionList();
    this.getIssueHistory();


  },

  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.popup {
  display: block;
  position: fixed;
  z-index: 1;
  padding-top: 60px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
}

/* Style for the close button */
.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* Style for the popup content (image) */
.popup-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add animation (optional) */
.popup-content {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
  from { -webkit-transform: scale(0); }
  to { -webkit-transform: scale(1); }
}

@keyframes zoom {
  from { transform: scale(0); }
  to { transform: scale(1); }
}

.text-right-input input {
  text-align: right;
}

.custom-align {
    text-align: right;
}
.asterisk {
  color: red;
}

.set-border {
  border: 1px solid #ddd;
}

/* .summary-footer {
  page-break-before: always;
} */

.modal {
  display: none;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

/* Style for the modal content */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

/* Style for the close button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

@media print {
  @page {
    margin-top: 0; /* Set the initial margin for the first page */
  }
}
</style>
